import { isInsideBlockByFlavour } from '@blocksuite/affine-shared/utils';
import { type SlashMenuConfig } from '@blocksuite/affine-widget-slash-menu';
import { viewPresets } from '@blocksuite/data-view/view-presets';
import {
  DatabaseKanbanViewIcon,
  DatabaseTableViewIcon,
  DateTimeIcon,
  TimelineIcon,
} from '@blocksuite/icons/lit';

import { insertSelectedDatabaseBlock } from '../commands';
import { isDatabaseCalendarViewCreationAllowed } from '../views';
import {
  CalendarViewTooltip,
  GanttViewTooltip,
  KanbanViewTooltip,
  TableViewTooltip,
} from './tooltips';

export const databaseSlashMenuConfig: SlashMenuConfig = {
  disableWhen: ({ model }) => model.flavour === 'affine:database',
  items: [
    {
      name: 'Table View',
      description: 'Display items in a table format.',
      searchAlias: ['database'],
      icon: DatabaseTableViewIcon(),
      tooltip: {
        figure: TableViewTooltip,
        caption: 'Table View',
      },
      group: '7_Database@0',
      when: ({ model }) =>
        !isInsideBlockByFlavour(model.store, model, 'affine:edgeless-text'),
      action: ({ std }) =>
        insertSelectedDatabaseBlock(std, viewPresets.tableViewMeta.type),
    },

    {
      name: 'Kanban View',
      description: 'Visualize data in a dashboard.',
      searchAlias: ['database'],
      icon: DatabaseKanbanViewIcon(),
      tooltip: {
        figure: KanbanViewTooltip,
        caption: 'Kanban View',
      },
      group: '7_Database@2',
      when: ({ model }) =>
        !isInsideBlockByFlavour(model.store, model, 'affine:edgeless-text'),
      action: ({ std }) =>
        insertSelectedDatabaseBlock(std, viewPresets.kanbanViewMeta.type),
    },

    {
      name: 'Gantt View',
      description: 'Plan tasks on a time axis with dependencies.',
      searchAlias: ['database', 'timeline', 'roadmap', 'schedule'],
      icon: TimelineIcon(),
      tooltip: {
        figure: GanttViewTooltip,
        caption: 'Gantt View',
      },
      group: '7_Database@3',
      when: ({ model }) =>
        !isInsideBlockByFlavour(model.store, model, 'affine:edgeless-text'),
      action: ({ std }) =>
        insertSelectedDatabaseBlock(std, viewPresets.ganttViewMeta.type),
    },

    {
      name: 'Calendar View',
      description: 'Schedule meetings, reminders, and recurring events.',
      searchAlias: ['database', 'calendar', 'meeting', 'schedule', 'termin'],
      icon: DateTimeIcon(),
      tooltip: {
        figure: CalendarViewTooltip,
        caption: 'Calendar View',
      },
      group: '7_Database@4',
      when: ({ model }) =>
        !isInsideBlockByFlavour(model.store, model, 'affine:edgeless-text') &&
        isDatabaseCalendarViewCreationAllowed(),
      action: ({ std }) =>
        insertSelectedDatabaseBlock(std, viewPresets.calendarViewMeta.type),
    },
  ],
};
